<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  })
};
</script>
<style scoped>
/* #app {
  background-image: url("http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/mobile");
  background-size: cover;
  background-attachment: fixed;
} */
</style>
